import React from 'react';
import { SectionWrapper } from './Shared';
import { Clock } from 'lucide-react';
export const StorySection = () => {
  return <SectionWrapper className="bg-dark-800 relative border-y border-white/5" data-id="element-181">
      <div className="max-w-3xl mx-auto" data-id="element-182">
        <div className="flex justify-center mb-8" data-id="element-183">
          <div className="w-16 h-16 rounded-full bg-dark-700 flex items-center justify-center border border-white/10 shadow-[0_0_20px_rgba(0,0,0,0.5)]" data-id="element-184">
            <Clock className="w-8 h-8 text-gold-500" data-id="element-185" />
          </div>
        </div>

        <div className="space-y-6 text-lg md:text-xl text-zinc-300 leading-relaxed font-light" data-id="element-186">
          <p className="first-letter:text-5xl first-letter:font-oswald first-letter:text-gold-500 first-letter:mr-3 first-letter:float-left" data-id="element-187">
            Es un martes cualquiera, son las 7:43 PM y acabas de llegar a casa.
            Estás sentado en el sofá mirando una pantalla, pero no ves nada. Tu
            cuerpo pesa como si estuviera hecho de plomo.
          </p>
          <p data-id="element-188">
            Tu pareja te habla y respondes con monosílabos. Tus hijos quieren
            jugar y tú, con un nudo en la garganta, les dices:{' '}
            <span className="italic text-white font-medium" data-id="element-189">
              "hoy no, papá está muy cansado"
            </span>
            .
          </p>
          <div className="h-px w-24 bg-gold-500/30 mx-auto my-8" data-id="element-190"></div>
          <p data-id="element-191">
            No estás enfermo. Los análisis dicen que estás "dentro del rango
            normal". Pero tú sabes la verdad: te has convertido en un espectador
            de tu propia vida.
          </p>
          <p className="text-white font-medium text-xl md:text-2xl text-center mt-8" data-id="element-192">
            El hombre que tenía proyectos, ambición y energía sobrante ha
            desaparecido.
          </p>
        </div>
      </div>
    </SectionWrapper>;
};